import React from "react";
import { snakeCase } from "lodash";
import clsx from "clsx";
import PropTypes from "prop-types";
import FormCheck from "react-bootstrap/FormCheck";

const GridRow = props => {
  const {
    className = "",
    rowIndex,
    rowItem,
    fields,
    selectableRows,
    checkRowSelected = () => undefined,
    onRowSelectChange = () => undefined,
    onClick = () => undefined,
    style = {},
    children,
    checkboxDisabled = false,
    checkCheckboxVisible = () => true,
    shouldMarkRow = () => undefined,
    cellClassName
  } = props;

  const isChecked = checkRowSelected(rowItem, rowIndex);
  const isCheckboxVisible = checkCheckboxVisible(rowItem, rowIndex);
  const { markRow, markRowClassName } = shouldMarkRow(rowItem) ?? {};

  return (
    <>
      <tr
        key={rowIndex}
        onClick={e => {
          if (!e.target.skipRowClick) {
            onClick(e);
          }
        }}
        style={style}
        className={clsx(
          className,
          isChecked && "row--selected",
          markRow && markRowClassName
        )}
        data-testid={`grid_row_${rowIndex}`}
      >
        {selectableRows && (
          <td className={cellClassName}>
            {isCheckboxVisible ? (
              <FormCheck
                type="checkbox"
                inline
                checked={isChecked}
                onClick={e => e.stopPropagation()}
                onChange={e => onRowSelectChange(rowItem, rowIndex)}
                className={`new-checkbox new-checkbox--table ${
                  isChecked ? "checked" : ""
                }`}
                data-testid={`row_select_checkbox_${rowIndex}`}
                disabled={checkboxDisabled}
              />
            ) : (
              <span />
            )}
          </td>
        )}
        {fields.map(field => (
          <td
            key={`${rowIndex}_${field.name}`}
            className={clsx(cellClassName, field.className)}
            style={field.style || {}}
            data-testid={snakeCase(`table_cell_${field.name}`)}
            rowSpan={field.rowSpan}
          >
            {field.component
              ? field.component(rowItem, rowIndex)
              : `${rowItem[field.name]}`}
          </td>
        ))}
      </tr>
      {children}
    </>
  );
};

GridRow.propTypes = {
  className: PropTypes.string,
  selectableRows: PropTypes.bool,
  checkRowSelected: PropTypes.func,
  onRowSelectChange: PropTypes.func,
  bulkSelected: PropTypes.bool,
  onClick: PropTypes.func,
  rowIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rowItem: PropTypes.object,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      sortable: PropTypes.bool,
      name: PropTypes.string,
      displayTitle: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
        PropTypes.element
      ]),
      component: PropTypes.oneOfType([PropTypes.func, PropTypes.element])
    })
  ),
  children: PropTypes.node,
  style: PropTypes.object,
  checkboxDisabled: PropTypes.bool,
  checkCheckboxVisible: PropTypes.func,
  cellClassName: PropTypes.string
};

export default GridRow;
